import { Configuration, PopupRequest } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${
      import.meta.env.VITE_AZURE_TENANT_ID
    }`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri:
      import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false,
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ["User.Read", "openid", "profile"],
};

// API configuration
export const apiConfig = {
  baseUrl:
    import.meta.env.VITE_API_BASE_URL ||
    (import.meta.env.PROD
      ? import.meta.env.VITE_ENVIRONMENT === "production"
        ? "https://purchase-approval-api-production.azurewebsites.net"
        : "https://purchase-approval-api-staging-d6hkhxfkgzhhakcx.germanywestcentral-01.azurewebsites.net"
      : "http://localhost:8080"),
  scopes: [
    `${
      import.meta.env.VITE_API_SCOPE || "api://purchase-approval-api"
    }/access_as_user`,
  ],
};
